<template>
  <div>
    <div
      v-if="masterDataTitle"
      class="row mb-1">
      <div class="col">
        {{ masterDataTitle }}
      </div>
    </div>
    <draggable
      v-model="input"
      v-bind="dragOptions"
      class="list-group"
      tag="ul"
      handle=".handle-dragable"
      @start="handleStartDrag"
      @end="handleEndDrag"
    >
      <transition-group
        :name="!drag ? 'flip-list' : null"
        type="transition">
        <li
          v-for="(item, index) in mapInput"
          :key="`${index}`"
          class="list-group-item"
        >
          <div class="wrapper-box">
            <div class="wrapper-box-form">
              <input
                :value="item.name"
                :disabled="disabled || item.deletable === false"
                class="form-control form-control-sm input-name"
                @keyup="handleInputChange($event, index)"
              >
              <div
                v-if="showCheckboxDefault"
                class="default"
              >
                <div class="form-check">
                  <input
                    :id="`${radioId}-${index}`"
                    :checked="item.is_default"
                    :value="item.name"
                    :disabled="disabled || !item.is_active || !item.name.trim().length"
                    :name="radioId"
                    class="form-check-input"
                    type="radio"
                    @change="handleRadioChange($event, index)"
                  >
                  <label
                    :for="`${radioId}-${index}`"
                    class="form-check-label"
                  >
                    {{ $t('message.default') }}
                  </label>
                </div>
              </div>
              <div class="active">
                <div class="form-check">
                  <input
                    :id="`${checkboxId}-${index}`"
                    :checked="item.is_active"
                    :disabled="disabled || item.is_default"
                    type="checkbox"
                    class="form-check-input"
                    @change="handleCheckboxChange($event, index)"
                  >
                  <label
                    :for="`${checkboxId}-${index}`"
                    class="form-check-label"
                  >
                    {{ $t('message.activate') }}
                  </label>
                </div>
              </div>
              <div class="delete">
                <button
                  :disabled="disabled || !item.deletable"
                  class="btn btn-light"
                  @click="removeAt(index)"
                >
                  <i class="far fa-trash-alt" />
                </button>
              </div>
              <div class="drag handle-dragable">
                <i class="fa fa-align-justify"/>
              </div>
            </div>
          </div>
        </li>
      </transition-group>
    </draggable>
    <button
      :disabled="disabled"
      class="btn btn-light btn-sm mt-3"
      @click="add"
    >
      {{ $t('button.addproduct') }}
    </button>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { cloneDeep } from 'lodash'
import { getMasterDataText } from '../../helpers'
import { uuid } from 'vue-uuid'

export default {
  components: {
    draggable,
  },

  props: {
    value: {
      type: Array,
    },
    disabled: {
      type: Boolean,
    },
    showCheckboxDefault: {
      type: Boolean,
      default: true,
    },
    masterDataTitle: {
      type: String,
    },
  },

  data () {
    return {
      input: [],
      drag: false,
    }
  },

  computed: {
    radioId () {
      return `${uuid.v1()}`
    },
    checkboxId () {
      return `${uuid.v1()}`
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
    mapInput() {
      return this.input.map((item) => {
        return {
          ...item,
          name: getMasterDataText(item.name, this.$t),
        }
      })
    },
  },

  watch: {
    value: {
      handler: function () {
        this.input = cloneDeep(this.value)
      },
      deep: true,
    },
  },

  created() {
    this.input = cloneDeep(this.value)
  },

  methods: {
    emitChange() {
      this.$emit('input', this.input)
    },
    handleStartDrag() {
      this.drag = true
      this.emitChange()
    },
    handleEndDrag() {
      this.drag = false
      this.emitChange()
    },
    removeAt(idx) {
      this.input.splice(idx, 1)
      this.emitChange()
    },
    add() {
      this.input.push({
        name: '',
        is_default: false,
        is_active: true,
        deletable: true,
      })
      this.emitChange()
    },
    handleInputChange(event, index) {
      this.input[index].name = event.target.value
      this.emitChange()
    },
    handleRadioChange(event, index) {
      this.input = this.input.map((item) => ({
        ...item,
        is_default: false,
      }))
      this.input[index].is_default = true
      this.emitChange()
    },
    handleCheckboxChange(event, index) {
      this.input[index].is_active = event.target.checked
      this.emitChange()
    },
  },
}
</script>

<style scoped>
.list-group-item {
  padding: 0;
  margin-bottom: 15px;
  background: none;
  border: none;
}
.list-group-item:last-of-type {
  margin-bottom: 0;
}

.wrapper-box {
  display: flex;
  gap: 20px;
}
.wrapper-box .wrapper-box-form {
  flex: 1;
  display: flex;
  background-color: #fff;
}
.wrapper-box .wrapper-box-form .default {
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #ced4da;
  border-left: none;
}
.wrapper-box .wrapper-box-form .active {
  min-width: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #ced4da;
  border-left: none;
}
.wrapper-box .wrapper-box-form .drag {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #ced4da;
  border-left: none;
  cursor: move;
}
.wrapper-box .wrapper-box-form .delete {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #ced4da;
  border-left: none;
}
.wrapper-box .wrapper-box-form .delete .btn {
  background: none;
  border-radius: 0;
  width: 100%;
}
.wrapper-box .wrapper-box-form .delete .btn:disabled i {
  opacity: .3;
}
.wrapper-box .wrapper-box-form .form-check-label {
  position: relative;
  top: 1px;
}
.wrapper-box .wrapper-box-form input.input-name {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/combine/CustomMasterDataForm.vue